import {NewviewOaBaseApi} from "./NewviewOaBaseApi";


export class QuestionTypeInstitutionApi extends NewviewOaBaseApi {

    public get ControllerName(): any {
        return 'question-type-institution'
    }

}